import React from 'react';
import Typography from 'components/gruenland/atoms/typography';
import { sortCategoryGroups } from 'helpers/categoryHelpers/categoryGroupSort';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';
import MobileMenuNavButton from '../atoms/MobileMenuNavButton';

interface CategoryGroupProps {
  categories: Category[];
  onCategorySelect: (category: Category) => void;
  onMenuClose: () => void;
}

export const CategoryGroup: React.FC<CategoryGroupProps> = ({ categories, onCategorySelect, onMenuClose }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const groups = sortCategoryGroups(categories);

  return (
    <>
      {groups.map((groupName, index) => (
        <div key={index} className="mb-5">
          <Typography className="font-bold">
            {formatMessage({
              id: `categoryGroup.${groupName}`,
              defaultMessage: groupName,
            })}
          </Typography>
          <div>
            {categories
              .filter((category) => category.customGroup === groupName)
              .map((category) => (
                <MobileMenuNavButton
                  key={category.categoryId}
                  link={category}
                  onClick={() => onCategorySelect(category)}
                  hideHeaderMenu={onMenuClose}
                />
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

interface CategoryListProps {
  categories: Category[];
  onCategorySelect: (category: Category) => void;
  onMenuClose: () => void;
}

export const CategoryList: React.FC<CategoryListProps> = ({ categories, onCategorySelect, onMenuClose }) => {
  return (
    <div className="space-y-1">
      {categories.map((category) => (
        <MobileMenuNavButton
          key={category.categoryId}
          link={category}
          onClick={() => onCategorySelect(category)}
          hideHeaderMenu={onMenuClose}
        />
      ))}
    </div>
  );
};
